import React, { FC } from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
  width?: number;
  height?: number;
}

export const IconCentralLocationMono: FC<React.PropsWithChildren<Props>> = ({ className, width = 32, height = 32 }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox={`0 0 18 18`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 5.71429C12.939 4.65384 11.4858 4 9.88286 4C6.63384 4 4 6.68629 4 10C4 13.3137 6.63384 16 9.88286 16C11.4858 16 12.939 15.3462 14 14.2857"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="10" cy="10" r="2" fill="currentColor" />
  </svg>
);
